<template>
    <div class="customer-orders-component">
        <mobile-go-back-button></mobile-go-back-button>
        <h2 class="mb-5">{{ trans.get("customer.my-orders") }}</h2>
        <div class="mdc-tab-bar mb-10" role="tablist">
            <div class="mdc-tab-scroller">
                <div class="mdc-tab-scroller__scroll-area">
                    <div class="mdc-tab-scroller__scroll-content">
                        <button
                            class="mdc-tab mdc-tab--active"
                            role="tab"
                            aria-selected="true"
                            tabindex="0"
                            @click="setOrdersShown('recent')"
                        >
                            <span class="mdc-tab__content">
                                <span class="mdc-tab__text-label"
                                    >{{ trans.get('customer.recent') }}</span
                                >
                            </span>
                            <span
                                class="mdc-tab-indicator mdc-tab-indicator--active"
                            >
                                <span
                                    class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"
                                ></span>
                            </span>
                            <span class="mdc-tab__ripple"></span>
                        </button>
                        <button
                            class="mdc-tab"
                            role="tab"
                            aria-selected="false"
                            tabindex="1"
                            @click="setOrdersShown('old')"
                        >
                            <span class="mdc-tab__content">
                                <span class="mdc-tab__text-label"
                                    >{{ trans.get('customer.old') }}</span
                                >
                            </span>
                            <span
                                class="mdc-tab-indicator"
                            >
                                <span
                                    class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"
                                ></span>
                            </span>
                            <span class="mdc-tab__ripple"></span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <p v-if="ordersShown === 'recent' && ordersFiltered.length === 0">{{ trans.get('customer.no-recent-orders') }}</p>
        <p v-else-if="ordersShown === 'old' && ordersFiltered.length === 0">{{ trans.get('customer.no-old-orders') }}</p>
        <div class="orders-grid" v-else>
            <customer-order v-for="order in ordersFiltered" :key="order.id" :order="order"></customer-order>
        </div>
    </div>
</template>

<script>
import { MDCTabBar } from "@material/tab-bar";
import CustomerOrder from './CustomerOrder';
import MobileGoBackButton from './MobileGoBackButton';

export default {
    components: {
        CustomerOrder,
        MobileGoBackButton,
    },

    data() {
        return {
            ordersShown: 'recent',
            ordersData: this.$store.state.customer.storedData.orders,
        };
    },

    computed: {
        ordersFiltered() {
            return this.ordersData[this.ordersShown];
        }
    },

    methods: {
        setOrdersShown(value) {
            this.ordersShown = value;
        }
    },

    mounted() {
        new MDCTabBar(this.$el.querySelector(".mdc-tab-bar"));
    }
};
</script>

<style lang="scss" scoped>
.mdc-tab-bar {
    width: 100%;
    max-width: 25rem;
}
.mdc-tab {
    margin: 0;
    padding: 0;
    font-family: "DM Sans", sans-serif;
}
.mdc-tab-scroller__scroll-content {
    width: 100%;
}
.orders-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem;
    max-width: 800px;
    align-items: start;

    @media (min-width: 640px) {
        grid-template-columns: 1fr 1fr;
    }
    @media (min-width: 1366px) {
        grid-template-columns: 1fr 1fr 1fr;
        max-width: 1200px;
        gap: 1.5rem 2rem;
    }

}
</style>
